export default "__VITE_ASSET__D9yyRF8$__"